import styled from 'styled-components';

export const ContainerSkeleton = styled.div`
  margin: 0 0 24px 0;
  display: flex; 
  flex-direction: column;
  overflow: hidden;
`;

export const SubContainerSkeleton = styled.div`
  margin: 0 0 16px 0;
  display: flex;
  flex-direction: row;
`;

export const MrSkeleton = styled.div`
margin-right: 8px;
`;


export const WrapSkeletons = styled.div`
display: flex;
width: 100%;
flex-direction: column;
`;

export const ContainerDivider = styled.div`
padding: 0 16px 16px 16px; 
`;

export const RowSkeleton = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const ColumnSkeleton = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ShopCardContainer = styled.div`
  height: 214px;
  width: 195px;
  border-radius: 8px;
  border: 1px solid #E7E6E9;
`;

export const DescriptionShopCard = styled.div`
  padding-left: 8px;
`;

export const SwiperContainer = styled.div`
  margin: 0 0 16px 0;
  overflow: hidden;
`;

export const ContainerSkeletonFood = styled.div`
  padding: ${props => props.isRevamp ? '0' : '16px 0 0 16px'};
`;